import * as React from "react";
import styled from "styled-components";

interface IProps {
    currentCount: number;
    totalCount: number;
}

const Wrapper = styled.div`
    margin-bottom: 0.5rem;
`;

function Counts({ currentCount, totalCount }: IProps) {
    return (
        <Wrapper>
            {currentCount === totalCount
                ? `Showing ${currentCount} items`
                : `Showing ${currentCount} of ${totalCount} items`}
        </Wrapper>
    );
}

export default React.memo(Counts);
